export const mouseEnter = 800;
export const mouseEnterShort = 100;
export const mouseLeave = 150;
export const defaultStyles = {
    left: 0,
    top: 0,
    width: "auto",
    height: "auto",
    zIndex: "var(--rs-z-index-flyout)",
};
export const resetStyles = {
    left: 0,
    top: 0,
    position: "absolute",
    visibility: "hidden",
    animation: "none",
    transition: "none",
    zIndex: "var(--rs-z-index-flyout)",
};
